import React, { Component } from "react";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Dropdown, Row, Col, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiPlusCircle, FiTrash2, FiEdit3, FiImage, FiEye } from "react-icons/fi";
import {
  FaRegFilePdf,
  FaRegImage,
  FaRegFileExcel,
  FaRegFileWord,
  FaRegTrashAlt,
  FaPen,
  FaEye,
  FaCheck,
  FaTimes,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { CountryService } from "app/_services/ConfigService/CountryService/CountryService";
import ApproveReject from "app/views/custom/components/ApproveReject/ApproveReject";
import toastr from "toastr";
import { SetGlobalPermission } from "app/Components/SetPermission/Permissions";
import LastLog from "app/views/custom/components/Logs/LastLog";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";

class Country extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      countryData: [],
    };
  }

  componentDidMount() {
    this.setCountryData();
  }

  setCountryData = async () => {
    let response = await CountryService.getCountryAll(this.state.projectId);

    if (response && response.status) {
      if (response.data && response.data.countryMaster) {
        this.setState(
          {
            countryData: response.data.countryMaster,
          },
          () => {
            let data = JSON.parse(JSON.stringify(this.state.countryData));
            Array.isArray(data) &&
              data.map((rowData, rowindex) => {
                let activeStatus = "";
                if (rowData.activeStatus === 1) {
                  activeStatus = "Active";
                } else if (rowData.activeStatus === 2) {
                  activeStatus = "In-Active";
                }

                rowData["sid"] = rowindex + 1;
                rowData["activeStatusView"] = activeStatus;
              });
            this.setState({
              countryData: data,
            });
          }
        );
      }
    } else {
      this.setState({
        countryData: [],
      });
    }
  };

  delete(e, projectId, id) {
    e.preventDefault();

    confirmAlert({
      title: "Delete Country",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const response = await CountryService.deleteCountry(projectId, id);

            if (response) {
              if (response.status) {
                toastr.info(response.message || "Country Deleted!");
                this.setCountryData();
              } else if (response.message) {
                toastr.info(response.message);
              }
            }
          },
        },
        {
          label: "No",
          onClick: () => console.log("test"),
        },
      ],
    });
  }

  tableToolbarView = () => {
    return (
      <SetGlobalPermission
        permission="global_globalConfiguration_add"
        data={
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Add Country</Tooltip>}
          >
            <Link
              className="icons btn-icon font-20 text-cyanBlue"
              to={"/global-configuration/project-details/country/add"}
            >
              <FiPlusCircle />
            </Link>
          </OverlayTrigger>
        }
      />
    );
  };

  render() {
    let { countryData, projectId, projectData } = this.state;
    let { SearchBar } = Search;
    let sortableColumn = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "name",
        text: "Country",
        sort: true,
      },
      {
        dataField: "activeStatusView",
        text: "Status",
        sort: true,
        // formatter: (rowContent, row, index) => {
        //   let activeStatus = "";
        //   if (row.activeStatus === 1) {
        //     activeStatus = "Active";
        //   } else if (row.activeStatus === 2) {
        //     activeStatus = "In-Active";
        //   }
        //   return activeStatus;
        // },
      },
      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          console.log("row", this);
          return (
            <div className="actionIconsGroup">
              <SetGlobalPermission
                permission={"global_globalConfiguration_view"}
                data={
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">View</Tooltip>}
                  >
                    <Link
                      to={"/global-configuration/project-details/country/view/" + row.id}
                      className="icons text-cyanBlue"
                    >
                      <FiEye />
                    </Link>
                  </OverlayTrigger>
                }
              ></SetGlobalPermission>

              <SetGlobalPermission
                permission={
                  row.status == 1
                    ? "global_globalConfiguration_editAfterApprove"
                    : "global_globalConfiguration_edit"
                }
                data={
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
                  >
                    <Link
                      to={"/global-configuration/project-details/country/edit/" + row.id}
                      className="icons text-cyanBlue"
                    >
                      <FiEdit3 />
                    </Link>
                  </OverlayTrigger>
                }
              ></SetGlobalPermission>

              {row.status == 1 ? (
                <SetGlobalPermission
                  permission="global_globalConfiguration_approve"
                  data={
                    <SetGlobalPermission
                      permission="global_globalConfiguration_delete"
                      data={
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                        >
                          <a
                            href="#"
                            className="icons text-danger"
                            onClick={(e) => this.delete(e, row.projectId, row.id)}
                          >
                            <FaRegTrashAlt />
                          </a>
                        </OverlayTrigger>
                      }
                    ></SetGlobalPermission>
                  }
                />
              ) : (
                <SetGlobalPermission
                  permission="global_globalConfiguration_delete"
                  data={
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                    >
                      <a
                        href="#"
                        className="icons text-danger"
                        onClick={(e) => this.delete(e, row.projectId, row.id)}
                      >
                        <FaRegTrashAlt />
                      </a>
                    </OverlayTrigger>
                  }
                ></SetGlobalPermission>
              )}

              <ApproveReject
                projectId={row.projectId}
                rowId={row.id}
                tableName={"country_master"}
                setData={this.setCountryData}
                permission="global_globalConfiguration_approve"
                status={row.status}
                global
              ></ApproveReject>
            </div>
          );
        },
      },
    ];

    let paginationOptions = {
      // custom: true,
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      totalSize: this.state.countryData.length,
    };

    return (
      <div>
        <MainBreadcrumb
          routeSegments={[{ name: "Global Settings", path: "#" }, { name: "Country" }]}
          breadCrumbsText="Configuration_Project_Details_Country"
        />
        <div className="overflow-inherit card p-4 mb-4">
          <SearchBootstrapTable
            data={countryData}
            columns={sortableColumn}
            tableToolbarView={this.tableToolbarView}
            downloadPermission={"configuration_RegulatoryCompliance_download"}
          />
        </div>
        <LastLog
          subModulename={"country-master"}
          // projectId={projectId}
        ></LastLog>
      </div>
    );
  }
}

export default Country;
